module.exports = __webpack_public_path__ + "img/North Korea.2f6d9c15.svg";